import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { inr } from "@/theme";
import { useAdminTheme } from "@/admin/AdminTheme";
import { ACard, AButton, Badge, StatCard, STATUS_TONE, AdminPageTitle } from "@/admin/ui";
import { Spinner } from "@/components/common";

export default function AdminCustomerDetail() {
  const { c } = useAdminTheme();
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => { api(`/admin/customers/${id}`).then(setData).catch(() => setData(null)); }, [id]);
  if (!data) return <Spinner full />;

  const u = data.user;
  return (
    <div className="fade-up" style={{ maxWidth: 860 }}>
      <AdminPageTitle title={u.name} subtitle={`${u.email} · ${u.mobile}`}
        action={<AButton variant="outline" onClick={() => navigate("/admin/customers")}>Back</AButton>} />

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px,1fr))", gap: 16, marginBottom: 18 }}>
        <StatCard label="Total Spent" value={inr(data.total_spent)} />
        <StatCard label="Orders" value={data.orders_count} />
        <StatCard label="Nest Points" value={data.points_balance} />
      </div>

      <ACard style={{ padding: 0, overflow: "hidden" }}>
        <h3 className="font-display" style={{ margin: 0, fontSize: 18, fontWeight: 700, padding: 18 }}>Order History</h3>
        {data.orders.length === 0 ? <p style={{ padding: "0 18px 18px", color: c.mutedText }}>No orders.</p> : data.orders.map((o) => (
          <div key={o.id} onClick={() => navigate(`/admin/order/${o.id}`)} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 18px", borderTop: `1px solid ${c.divider}`, cursor: "pointer" }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: 13.5 }}>#{o.id.slice(0, 8)}</div>
              <div style={{ fontSize: 12, color: c.mutedText }}>{new Date(o.created_at).toLocaleDateString()}</div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontWeight: 700 }}>{inr(o.amount)}</span>
              <Badge tone={STATUS_TONE[o.status]}>{o.status}</Badge>
            </div>
          </div>
        ))}
      </ACard>
    </div>
  );
}
